import { backendApi, Result } from "./backendApi";

export interface RoofInfoTypeModel {
  id?: number;
  info?: string;
  english?: string;
  dutch?: string;
  german?: string;
  french?: string;
  spanish?: string;
  portugues?: string;
  italian?: string;
  polish?: string;
  czech?: string;
  swedish?: string;
  danish?: string;
  norwegian?: string;
  finnish?: string;
  hungarian?: string;
  croatian?: string;
  hebrew?: string;
  slovene?: string;
  russian?: string;
  arabic?: string;
  ukrainian?: string;
}

class GetRoofInfoTypesRequest {}

class GetRoofInfoTypesResponse {
  roofInfoTypes?: RoofInfoTypeModel[];
}

export const roofInfoTypeApi = {
  async getRoofInfoTypes(): Promise<Result<RoofInfoTypeModel[]>> {
    let response =
      await backendApi.sendAndGetResponseAsync<GetRoofInfoTypesResponse>(
        "GetRoofInfoTypes",
        new GetRoofInfoTypesRequest(),
      );

    if (response.ok) {
      return { ok: true, value: response.value.roofInfoTypes ?? [] };
    }

    return response;
  },
};
